import { getWebsiteContactUrl } from '@/ui/helpers/websiteHelper';
import { NamedRouteConfig } from '@/ui/routes/types';
import { WelcomePage } from '@/ui/pages/WelcomePage';
import { guardAuthenticatedRoutes, guardGuestRoutes } from '@/ui/routes/guards';
import { RegisterPage } from '@/ui/pages/auth/register/RegisterPage';
import { getLocale, localeParamName } from '@/ui/routes/guestRoutes';
import { LoginPage } from '@/ui/pages/auth/LoginPage';
import { SsoLoginPage } from '@/ui/pages/auth/SsoLoginPage';
import { SsoVerifyPage } from '@/ui/pages/auth/SsoVerifyPage';
import { CenteredTitleSubtitlePage } from '@/ui/pages/subscription/CenteredTitleSubtitlePage';
import { SubscribePage } from '@/ui/pages/subscription/SubscribePage';
import { guardSubscriptionRoutes } from '@/ui/routes/guards/guardSubscriptionRoutes';
import { multiguard } from '@/ui/routes/guards/multiguard';
import { guardOnboardingFeatureToggle } from '@/ui/routes/guards/guardOnboardingFeatureToggle';
import { guardOnboardingStatus } from '@/ui/routes/guards/guardOnboardingStatus';
import OnboardingPage from '@/ui/pages/newOnboarding/OnboardingPage.vue';
import FreePlanEnd from '@/ui/pages/subscription/Chargebee/subscribe/FreePlanEnd.vue';

const logoLayoutRoutes: NamedRouteConfig[] = [
  {
    path: '/welcome',
    name: 'welcomePageMobile',
    component: WelcomePage,
    beforeEnter: guardAuthenticatedRoutes,
  },
  {
    path: `/:${localeParamName}?/register`,
    name: 'register',
    beforeEnter: () => {
      window.location.replace(getWebsiteContactUrl());
      return '';
    },
  },
  {
    //hidden route only for sales
    path: `/:${localeParamName}?/signup`,
    name: 'signup',
    component: RegisterPage,
    props: getLocale,
    beforeEnter: guardGuestRoutes,
  },
  {
    path: `/:${localeParamName}?/login`,
    name: 'login',
    component: LoginPage,
    props: getLocale,
    beforeEnter: guardGuestRoutes,
  },
  {
    path: `/:${localeParamName}?/login-sso`,
    name: 'ssoLogin',
    component: SsoLoginPage,
    props: getLocale,
    beforeEnter: guardGuestRoutes,
  },
  {
    path: `/:${localeParamName}?/sso/verify`,
    name: 'ssoVerify',
    component: SsoVerifyPage,
    props: getLocale,
    beforeEnter: guardGuestRoutes,
  },
  {
    path: '/past-due-subscription',
    name: 'pastDueNoManageBillingPermission',
    component: CenteredTitleSubtitlePage,
    props: {
      title: 'trial-end.problem-with-subscription',
      subtitle: 'trial-end.contact-your-administrator',
    },
    meta: {
      classes: 'centered-title-subtitle-layout',
    },
    beforeEnter: guardAuthenticatedRoutes,
  },
  {
    path: '/subscribe',
    name: 'subscribe',
    component: SubscribePage,
    beforeEnter: guardSubscriptionRoutes,
  },
  {
    path: '/free-plan-ended',
    name: 'freePlanEnded',
    component: FreePlanEnd,
    beforeEnter: guardSubscriptionRoutes,
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    beforeEnter: multiguard([guardAuthenticatedRoutes, guardOnboardingFeatureToggle, guardOnboardingStatus]),
    component: OnboardingPage,
    meta: {
      disablePadding: true,
    },
  },
];

export default logoLayoutRoutes;
